import { Navigation, FreeMode } from 'swiper/modules'
import { STATIC_URL } from 'constants/data'

const swiperProps = {
  slidesPerView: 'auto',
  freeMode: true,
  speed: 500,
  spaceBetween: '15px',
  modules: [Navigation, FreeMode],
}

const imgLogo = {
  src: `${STATIC_URL}/ai-bolit/aibolit-logo.png`,
  alt: 'AI-Bolit',
  width: 64,
  height: 68,
  unoptimized: true,
}
const imgDesktop = {
  src: `${STATIC_URL}/ai-bolit/header-bg.png`,
  alt: 'AI-Bolit - умный помощник для врачей на основе искусственного интеллекта',
  width: 401,
  height: 386,
  unoptimized: true,
}

const imgMobile = {
  src: `${STATIC_URL}/ai-bolit/header-bg-mob.png`,
  alt: 'AI-Bolit - умный помощник для врачей на основе искусственного интеллекта',
  width: 330,
  height: 275,
  unoptimized: true,
}

const points = [
  {
    imgData: {
      src: `${STATIC_URL}/ai-bolit/icon-header-1.png`,
      alt: 'Надежность и актуальность клинических рекомендаций в AI-Bolit',
      width: 54,
      height: 54,
      unoptimized: true,
    },
    title: 'Надежность',
    subtitle: 'Проверенные клинические рекомендации',
  },

  {
    imgData: {
      src: `${STATIC_URL}/ai-bolit/icon-header-2.png`,
      alt: 'Быстрый доступ к медицинской информации для врачей всех специальностей',
      width: 54,
      height: 54,
      unoptimized: true,
    },
    title: 'Скорость',
    subtitle: 'Мгновенные ответы на вопросы',
  },

  {
    imgData: {
      src: `${STATIC_URL}/ai-bolit/icon-header-3.png`,
      alt: 'Универсальное решение для врачей любых специальностей от терапевтов до узких специалистов',
      width: 54,
      height: 54,
      unoptimized: true,
    },
    title: 'Универсальность',
    subtitle: 'Для врачей всех специальностей',
  },
]

export { points, imgMobile, imgDesktop, imgLogo, swiperProps }
